import { AlertType, SmartAlertRunItem } from "@coeff/api";

export const NEW_ROW_ALERT_TYPES: Array<AlertType> = [
  AlertType.NewRowsAppended,
  AlertType.NewRowsWithId,
];

/**
 * Get the count of successfully delivered alerts from a smart alert run.
 * Handles both fanout (per_row) and non-fanout runs.
 */
export const getSmartAlertSuccessfulDeliveryCount = (run: SmartAlertRunItem): number => {
  if (run.status === "failed" || run.status === "trigger_not_met") {
    return 0;
  }
  // Check fanout results first (per_row granularity)
  if (run.fanout_results && run.fanout_results.length > 0) {
    return run.fanout_results.reduce((total, result) => {
      if (result.error) {
        return total;
      } // Skip failed fanout items
      return (
        total + (result.emails_sent ?? 0) + (result.slack_sent ?? 0) + (result.ms_teams_sent ?? 0)
      );
    }, 0);
  }
  // Fall back to run-level counts for non-fanout runs
  return (
    (run.emails_sent ?? 0) + (run.slack_messages_sent ?? 0) + (run.ms_teams_messages_sent ?? 0)
  );
};
